import {i18n} from '@online-offer/i18n';
import {Heading, HStack, Text, ThemeColorTextPath} from 'platform/foundation';

type TimerType = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  textColor?: ThemeColorTextPath;
};

export const Timer = (props: TimerType) => (
  <HStack align="center" spacing={2}>
    <HStack justify="center" align="center" spacing={1}>
      <Heading size={3} color={props.textColor}>
        {props.days.toString()}
      </Heading>
      <Text size="small" color={props.textColor}>
        {i18n.t('timerCard.timer.d')}
      </Text>
    </HStack>
    <Heading size={3} color="tertiary">
      :
    </Heading>
    <HStack justify="center" align="center" spacing={1}>
      <Heading size={3} color={props.textColor}>
        {props.hours.toString().padStart(2, '0')}
      </Heading>
      <Text size="small" color={props.textColor}>
        {i18n.t('timerCard.timer.h')}
      </Text>
    </HStack>
    <Heading size={3} color="tertiary">
      :
    </Heading>
    <HStack justify="center" align="center" spacing={1}>
      <Heading size={3} color={props.textColor}>
        {props.minutes.toString().padStart(2, '0')}
      </Heading>
      <Text size="small" color={props.textColor}>
        {i18n.t('timerCard.timer.m')}
      </Text>
    </HStack>
    <Heading size={3} color="tertiary">
      :
    </Heading>
    <HStack justify="center" align="center" spacing={1}>
      <Heading size={3} color={props.textColor}>
        {props.seconds.toString().padStart(2, '0')}
      </Heading>
      <Text size="small" color={props.textColor}>
        {i18n.t('timerCard.timer.s')}
      </Text>
    </HStack>
  </HStack>
);
